// List of courses of study in Ghanaian universities
export const ghanaCourses = [
  // Business & Management
  "Accounting",
  "Banking and Finance",
  "Business Administration",
  "Business Management",
  "Commerce",
  "Economics",
  "Entrepreneurship",
  "Finance",
  "Human Resource Management",
  "Insurance",
  "International Business",
  "Marketing",
  "Public Administration",
  "Supply Chain Management",
  "Tourism and Hospitality Management",
  
  // Engineering
  "Aerospace Engineering",
  "Agricultural Engineering",
  "Biomedical Engineering",
  "Chemical Engineering",
  "Civil Engineering",
  "Computer Engineering",
  "Electrical Engineering",
  "Electronic Engineering",
  "Environmental Engineering",
  "Food Process Engineering",
  "Geological Engineering",
  "Industrial Engineering",
  "Materials Engineering",
  "Mechanical Engineering",
  "Metallurgical Engineering",
  "Mining Engineering",
  "Petroleum Engineering",
  "Telecommunication Engineering",
  
  // Computer Science & IT
  "Artificial Intelligence",
  "Computer Science",
  "Cyber Security",
  "Data Science",
  "Information Systems",
  "Information Technology",
  "Mobile Application Development",
  "Network Engineering",
  "Software Engineering",
  "Web Development",
  
  // Health Sciences
  "Anesthesia",
  "Biomedical Science",
  "Dentistry",
  "Dietetics",
  "Medical Laboratory Science",
  "Medicine",
  "Midwifery",
  "Nursing",
  "Nutrition",
  "Occupational Therapy",
  "Optometry",
  "Pharmacy",
  "Physical Therapy",
  "Physician Assistant Studies",
  "Public Health",
  "Radiography",
  "Speech Therapy",
  "Veterinary Medicine",
  
  // Arts & Humanities
  "African Studies",
  "Archaeology",
  "Arts",
  "Classics",
  "Communication Studies",
  "Dance",
  "English",
  "Film Studies",
  "Fine Arts",
  "French",
  "Geography",
  "History",
  "Languages",
  "Linguistics",
  "Literature",
  "Media Studies",
  "Modern Languages",
  "Music",
  "Philosophy",
  "Religious Studies",
  "Theatre Arts",
  "Translation",
  
  // Education
  "Adult Education",
  "Basic Education",
  "Childhood Education",
  "Curriculum Studies",
  "Education",
  "Educational Administration",
  "Educational Leadership",
  "Educational Psychology",
  "Physical Education",
  "Science Education",
  "Special Education",
  "Teacher Education",
  
  // Law
  "Law",
  "Legal Studies",
  
  // Natural Sciences
  "Actuarial Science",
  "Agricultural Science",
  "Animal Science",
  "Applied Mathematics",
  "Biochemistry",
  "Biology",
  "Botany",
  "Chemistry",
  "Crop Science",
  "Environmental Science",
  "Fisheries",
  "Food Science",
  "Forestry",
  "Geology",
  "Horticulture",
  "Marine Science",
  "Mathematics",
  "Meteorology",
  "Microbiology",
  "Molecular Biology",
  "Natural Resource Management",
  "Physics",
  "Statistics",
  "Zoology",
  
  // Social Sciences
  "Anthropology",
  "Criminology",
  "Development Studies",
  "International Relations",
  "Political Science",
  "Psychology",
  "Social Work",
  "Sociology",
  
  // Architecture & Design
  "Architecture",
  "Fashion Design",
  "Graphic Design",
  "Industrial Design",
  "Interior Design",
  "Landscape Architecture",
  "Urban Planning"
];
